export default __webpack_public_path__ + "static/media/button-group-vs-dropdown-correct.3ab526fd.svg";